export default __webpack_public_path__ + "static/Eco-A-4fa267890ea85267a8c5aa547eec84b8.gif";